import React from 'react';
import Container from '../../components/layout/Container/Container';
import Card, { CardBody } from '../../components/ui/Card/Card';
import LoginForm from '../../features/auth/components/LoginForm/LoginForm';
import './AdminLogin.css';

const AdminLogin = () => {
  return (
    <div className="admin-login-page bg-light">
      <Container>
        <div className="admin-login-wrapper">
          <Card className="shadow-sm border-0">
            <CardBody>
              <p className="text-uppercase text-muted small mb-2">Admin Access</p>
              <LoginForm title="Admin Login" redirectTo="/admin" />
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default AdminLogin;
